import { RetailerKey } from '@vizit/constants';
import { OrganizationDialog } from '@vizit/organisms';
import { type UseCreateOrganizationDialogProps, useCreateOrganizationDialog } from './create-org-dialog.hooks';

const DEFAULT_VALUES = { retailers: [RetailerKey.WalmartUS] };
const DISABLED_RETAILERS = [RetailerKey.AmazonUS];

interface CreateOrgDialogProps extends UseCreateOrganizationDialogProps {
  /**
   * Whether the dialog is open
   *
   * @optional
   * @type boolean
   * @default false
   */
  isOpen?: boolean;
  /**
   * The user id
   *
   * @optional
   * @type string | null
   */
  userId?: string | null;
  /**
   * The user email
   *
   * @optional
   * @type string | null
   */
  userEmail?: string | null;
}

function CreateOrgDialog(props: CreateOrgDialogProps) {
  const { isOpen, userId, userEmail } = props;
  const { icpProductCategories, retailerRegions, onCreateOrganization } = useCreateOrganizationDialog({
    userId,
    userEmail,
  });

  return (
    <OrganizationDialog
      isOpen={isOpen}
      variant="create"
      onSubmit={onCreateOrganization}
      id="create-organization"
      icpProductCategories={icpProductCategories}
      retailerRegions={retailerRegions}
      defaultValues={DEFAULT_VALUES}
      disabledRetailers={DISABLED_RETAILERS}
    />
  );
}

export { CreateOrgDialog };
export type { CreateOrgDialogProps };
